module.exports = __webpack_public_path__ + "static/media/stilly3.fbc05f33.JPG";